<template>
  <div v-if="displayField">
    <div class="row form-group clearfix">
    <div class="col-md-3 col-lg-3 col-xl-3 mt-2"> <!-- Added spacing for the select dropdown -->
      <label class="h6 col-md-right" width="100%">
        Financial Month
      </label>  
    </div>
    <div class="col-md-9 col-lg-9 col-xl-9">
      <select v-model="FieldSelect" @change="onSelectOption($event)" class="form-control mr-2"> <!-- Adjusted width to 30% and added margin-right -->
        <option class="list-group-item" v-for="info in options" :value="info">
          {{ info }}
        </option>
      </select>
      <!-- Add additional content here if needed -->
      </div>
    </div>
  </div>
</template>

<script>
require('vue-select-image/dist/vue-select-image.css')
export default {
  props: [
    'label',
    'labelSecondary',
    'isRequired',
    'displayField',
    'errorClass',
    'categoryNomination',
    'checkboxLabels'
  ],
  data () {
    return {
      options:null,
      behavioursChild:null,
      parentcategory:null,
      FieldSelect: '',
      ShowSelect: true
    }
  },
  created () {
    console.log(' FieldSelect vue component called ')  
    var self = this
    //self.displayField = window.location.href.includes('employee-award')
    self.options= []
    if (window.location.href.includes('employee-award-legacy')) {
        const currentDate = new Date()
        const currentYear = currentDate.getFullYear()
        const currentMonth = currentDate.getMonth() + 1 // Adding 1 to get 1-based month index
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
        // Add current month and previous month to the options array
        if (currentMonth > 1) {
          if (currentMonth > 5) {
		    console.log(' FieldSelect vue component called FieldSelect month ', months[currentMonth - 2])
		    for (let monthIndex = 3; monthIndex < currentMonth-1; monthIndex++) {
		      console.log(' FieldSelect monthIndex ', monthIndex, months[monthIndex], currentMonth)
		      self.options.push(months[monthIndex] + ' ' + currentYear)
		    }              
          } else if (months[currentMonth - 2] !== 'March') {
            self.options.push(months[currentMonth - 2] + ' ' + currentYear)
          }
        } else {
          self.options.push(months[11] + ' ' + (currentYear - 1)) // December of previous year
        }
        self.options.push(months[currentMonth - 1] + ' ' + currentYear) // Current month
        console.log(' FieldSelect 67 ', (currentMonth - 1))
        self.FieldSelect = self.options[self.options.length-1] // Set the default selected option to the current month
    }
    if (window.location.href.includes('employee-award')) {
      const currentDate = new Date()
      let currentYear = currentDate.getFullYear()
      let currentMonth = currentDate.getMonth() + 1
      const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ]

      // Loop for last 6 months (including current)
      for (let i = 0; i < 6; i++) {
        let month = currentMonth - i
        let year = currentYear

        // If month goes below 1, wrap to previous year
        if (month <= 0) {
          month += 12
          year -= 1
        }

        self.options.push(months[month - 1] + ' ' + year)
      }

      // Reverse so oldest appears first (optional)
      self.options.reverse()

      console.log(self.options)
      self.FieldSelect = self.options[self.options.length-1] // Set the default selected option to the current month
    }
    console.log(' FieldSelect vue component called created Field updated with content: inside component addedSelectContent ', self.label, self.FieldSelect, self.displayField)
    self.$emit('addedCheckBoxesContent', {label: self.label, content: self.FieldSelect, validated: true, displayField: self.displayField})
  },
  methods: {
    onSelectOption() {
      console.log(' FieldSelect vue component called onSelectOption Field updated with content: inside component addedSelectContent ', this.label, this.FieldSelect, this.displayField)
      this.$emit('addedCheckBoxesContent', {label: this.label, content: this.FieldSelect, validated: true, displayField: this.displayField})    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FieldSelect.vue